module.exports = __webpack_public_path__ + "img/cmbs-data-accurate-info.ad02aa04.svg";